import { useTranslation } from "react-i18next";
import type { Celebrity } from "../../lib/types";

interface SearchResultProps {
  celebrity: Celebrity;
  onSelect: () => void;
  isActive?: boolean;
  id?: string;
}

export function SearchResult({
  celebrity,
  onSelect,
  isActive,
  id,
}: SearchResultProps) {
  const { t } = useTranslation();

  const sourceLabel =
    celebrity.source === "tmdb"
      ? t("source.tmdb")
      : celebrity.source === "comicvine"
        ? t("source.comicvine")
        : t("source.wikidata");

  return (
    <button
      id={id}
      type="button"
      onClick={onSelect}
      className={`w-full flex items-center gap-3 p-3 rounded-lg transition-colors text-left cursor-pointer ${
        isActive
          ? "bg-stone-100 dark:bg-stone-800"
          : "hover:bg-stone-100 dark:hover:bg-stone-800"
      }`}
    >
      {celebrity.image_url ? (
        <img
          src={celebrity.image_url}
          alt={celebrity.name}
          width={40}
          height={40}
          className="rounded-full object-cover flex-shrink-0"
          style={{ width: 40, height: 40 }}
        />
      ) : (
        <div
          className="rounded-full bg-stone-200 dark:bg-stone-600 text-stone-600 dark:text-stone-200 flex items-center justify-center font-semibold flex-shrink-0 text-sm"
          style={{ width: 40, height: 40 }}
        >
          {celebrity.name.charAt(0).toUpperCase()}
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-stone-900 dark:text-stone-100 truncate">
            {celebrity.name}
          </span>
          <span
            className={`flex-shrink-0 text-[10px] font-medium px-1.5 py-0.5 rounded uppercase tracking-wide ${
              celebrity.source === "tmdb"
                ? "bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400"
                : celebrity.source === "comicvine"
                  ? "bg-red-100 dark:bg-red-900/40 text-red-600 dark:text-red-400"
                  : "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400"
            }`}
          >
            {sourceLabel}
          </span>
        </div>
        {celebrity.known_for.length > 0 && (
          <div className="text-xs text-stone-500 dark:text-stone-400 truncate">
            {celebrity.known_for.join(", ")}
          </div>
        )}
      </div>
    </button>
  );
}
